// TEMPORARY FLAGS — set to false (or delete this file + its callers)
// to restore the original behavior.
//
// BUY_NOW_MODE: when true, the Home page "Paket Produk" card shows a
// "Buy Now" CTA that always navigates to checkout, ignoring the
// `isSubscribedToFirst` state. When false, the original
// "Subscribe Now" / "Subscribed" behavior is restored.
//
// To revert:
//   1. Set BUY_NOW_MODE = false, OR
//   2. Remove imports of BUY_NOW_MODE in src/pages/home/index.tsx and
//      delete this file.
export const BUY_NOW_MODE = true
